var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("functional-calendar", {
        ref: "BookingCalendar",
        attrs: { configs: _vm.calendarConfigs, name: "date_range" },
        scopedSlots: _vm._u([
          {
            key: "dateRangeInputs",
            fn: function(props) {
              return [
                _c(
                  "label",
                  {
                    class: "booking-calendar-input-label",
                    attrs: { for: "check-in" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticStyle: { "vertical-align": "middle" },
                        attrs: {
                          width: "21",
                          height: "23",
                          viewBox: "0 0 21 23",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d:
                              "M17.5493 8.73181H3.4507V20.2052H17.5493V8.73181ZM4.46948 19.1852V9.75184H16.5305V19.1852H4.46948Z",
                            fill: "black"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d:
                              "M5.32394 0C4.66902 0 4.14085 0.53697 4.14085 1.19594V1.74645H1.52817C0.682665 1.74645 0 2.4398 0 3.29168V21.4548C0 22.3066 0.682665 23 1.52817 23H19.4718C20.3173 23 21 22.3067 21 21.4548V3.29168C21 2.4398 20.3173 1.74645 19.4718 1.74645H16.8592V1.19594C16.8592 0.53697 16.331 0 15.6761 0C15.0211 0 14.493 0.53697 14.493 1.19594V1.74645H6.50704V1.19594C6.50704 0.53697 5.97887 0 5.32394 0ZM5.12676 1.19594C5.12676 1.08328 5.21656 0.994718 5.32394 0.994718C5.43133 0.994718 5.52113 1.08328 5.52113 1.19594V3.29168C5.52113 3.40434 5.43133 3.4929 5.32394 3.4929C5.21656 3.4929 5.12676 3.40434 5.12676 3.29168V1.19594ZM15.4789 1.19594C15.4789 1.08328 15.5687 0.994718 15.6761 0.994718C15.7834 0.994718 15.8732 1.08328 15.8732 1.19594V3.29168C15.8732 3.40434 15.7834 3.4929 15.6761 3.4929C15.5687 3.4929 15.4789 3.40434 15.4789 3.29168V1.19594ZM0.985916 3.29168C0.985916 2.98611 1.23021 2.74117 1.52817 2.74117H4.14085V3.29168C4.14085 3.95065 4.66902 4.48762 5.32394 4.48762C5.97887 4.48762 6.50704 3.95065 6.50704 3.29168V2.74117H14.493V3.29168C14.493 3.95065 15.0211 4.48762 15.6761 4.48762C16.331 4.48762 16.8592 3.95065 16.8592 3.29168V2.74117H19.4718C19.7698 2.74117 20.0141 2.98611 20.0141 3.29168V5.93793H0.985916V3.29168ZM0.985916 21.4548V6.93265H20.0141V21.4548C20.0141 21.7603 19.7698 22.0053 19.4718 22.0053H1.52817C1.23021 22.0053 0.985916 21.7603 0.985916 21.4548Z",
                            fill: "black"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      class: "booking-calendar-input",
                      attrs: {
                        id: "check-in",
                        type: "text",
                        title: "Start Date",
                        name: "start_date",
                        placeholder: "Check In",
                        readonly: !props.isTypeable,
                        "valid-scope": "booking-form"
                      },
                      domProps: {
                        value: props.startDate
                          ? _vm
                              .moment(props.startDate, "DD/MM/YYYY")
                              .format("DD-MM-YYYY")
                          : null
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "hidden", name: "start_date" },
                      domProps: {
                        value: _vm
                          .moment(props.startDate, "DD/MM/YYYY")
                          .format("YYYY-MM-DD")
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    class: "booking-calendar-input-label",
                    attrs: { for: "check-out" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticStyle: { "vertical-align": "middle" },
                        attrs: {
                          width: "21",
                          height: "23",
                          viewBox: "0 0 21 23",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d:
                              "M17.5493 8.73181H3.4507V20.2052H17.5493V8.73181ZM4.46948 19.1852V9.75184H16.5305V19.1852H4.46948Z",
                            fill: "black"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d:
                              "M5.32394 0C4.66902 0 4.14085 0.53697 4.14085 1.19594V1.74645H1.52817C0.682665 1.74645 0 2.4398 0 3.29168V21.4548C0 22.3066 0.682665 23 1.52817 23H19.4718C20.3173 23 21 22.3067 21 21.4548V3.29168C21 2.4398 20.3173 1.74645 19.4718 1.74645H16.8592V1.19594C16.8592 0.53697 16.331 0 15.6761 0C15.0211 0 14.493 0.53697 14.493 1.19594V1.74645H6.50704V1.19594C6.50704 0.53697 5.97887 0 5.32394 0ZM5.12676 1.19594C5.12676 1.08328 5.21656 0.994718 5.32394 0.994718C5.43133 0.994718 5.52113 1.08328 5.52113 1.19594V3.29168C5.52113 3.40434 5.43133 3.4929 5.32394 3.4929C5.21656 3.4929 5.12676 3.40434 5.12676 3.29168V1.19594ZM15.4789 1.19594C15.4789 1.08328 15.5687 0.994718 15.6761 0.994718C15.7834 0.994718 15.8732 1.08328 15.8732 1.19594V3.29168C15.8732 3.40434 15.7834 3.4929 15.6761 3.4929C15.5687 3.4929 15.4789 3.40434 15.4789 3.29168V1.19594ZM0.985916 3.29168C0.985916 2.98611 1.23021 2.74117 1.52817 2.74117H4.14085V3.29168C4.14085 3.95065 4.66902 4.48762 5.32394 4.48762C5.97887 4.48762 6.50704 3.95065 6.50704 3.29168V2.74117H14.493V3.29168C14.493 3.95065 15.0211 4.48762 15.6761 4.48762C16.331 4.48762 16.8592 3.95065 16.8592 3.29168V2.74117H19.4718C19.7698 2.74117 20.0141 2.98611 20.0141 3.29168V5.93793H0.985916V3.29168ZM0.985916 21.4548V6.93265H20.0141V21.4548C20.0141 21.7603 19.7698 22.0053 19.4718 22.0053H1.52817C1.23021 22.0053 0.985916 21.7603 0.985916 21.4548Z",
                            fill: "black"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "`required`"
                        }
                      ],
                      class: "booking-calendar-input",
                      attrs: {
                        id: "check-out",
                        name: "end_date",
                        type: "text",
                        title: "End Date",
                        placeholder: "Check Out",
                        readonly: !props.isTypeable,
                        "valid-scope": "booking-form"
                      },
                      domProps: {
                        value: props.endDate
                          ? _vm
                              .moment(props.endDate, "DD/MM/YYYY")
                              .format("DD-MM-YYYY")
                          : null
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "hidden", name: "end_date" },
                      domProps: {
                        value: _vm
                          .moment(props.endDate, "DD/MM/YYYY")
                          .format("YYYY-MM-DD")
                      }
                    })
                  ]
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      }),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.upload_id
            ) + "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "`required`"
              }
            ],
            attrs: {
              type: "file",
              name: "document",
              accept: "application/pdf, image/*",
              "valid-scope": "booking-form"
            }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.model &&
      _vm.model.dateRange &&
      _vm.model.dateRange.start &&
      _vm.model.dateRange.end
        ? [
            _c(
              "div",
              [
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm
                          .moment(_vm.model.dateRange.end, "DD/MM/YYYY")
                          .diff(
                            _vm.moment(_vm.model.dateRange.start, "DD/MM/YYYY"),
                            "days"
                          ) + 1
                      ) +
                      "\n        " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.days
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "booking-form__row d-flex --aligned-horizontally"
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.properties &&
                            _vm.locales.properties.price
                        ) + ":"
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "right-aligned" }, [
                      _vm._v("€ " + _vm._s(_vm.bookPrice.toFixed(2)))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.extraPrices, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "booking-form__row d-flex d-flex--aligned-horizontally"
                    },
                    [
                      _c("strong", [_vm._v(_vm._s(item.name) + ":")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "right-aligned" }, [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm.getPeriodPrice(item.price, "month").toFixed(2)
                            )
                        )
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "booking-form__row d-flex d-flex--aligned-horizontally"
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.common &&
                            _vm.locales.common.total
                        ) + ":"
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "right-aligned" }, [
                      _vm._v("€ " + _vm._s(_vm.total.toFixed(2)))
                    ])
                  ]
                )
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a61edbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a61edbc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/BookingForm.vue
// module id = 564
// module chunks = 1